import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../../../../utils/contants";

const getBackgroundColor = (variant) => {
  if (variant === "purple") return COLOUR_CONSTANT.theme.purple.light;
  if (variant === "dark") return "#301D35";
  if (variant === "light") return "#fff";
};

const getColor = (variant) => {
  if (variant === "purple") return COLOUR_CONSTANT.theme.background.dark;
  if (variant === "dark") return "#fff";
  if (variant === "light") return "#301D35";
};

export const AccordianStyled = styled.div`
  .expanded {
    .MuiAccordionSummary-root {
      border-bottom-left-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }
  }
  .MuiAccordionSummary-root {
    flex-direction: ${(props) =>
      props.arrowPosition === "right" ? "auto" : "row-reverse"};
    border-radius: 5px;
    gap: 10px;
    background-color: ${(props) => getBackgroundColor(props?.variant)};
    color: ${(props) => getColor(props.variant)};
    align-items: baseline;

    .MuiAccordionSummary-expandIconWrapper {
      transform: ${(props) =>
        props.arrowPosition === "right" ? " rotate(90deg);" : "auto"};
      svg {
        color: ${(props) => (props.variant === "dark" ? "white" : "#301D35")};
      }
    }
    .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
      transform: rotate(-90deg);
    }
  }
  .MuiAccordion-root {
    box-shadow: none;
    border: 1px solid var(--flow-30-neutral-3, #efedfd);
  }
`;
